module.exports = __webpack_public_path__ + "static/media/download.d996cc01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/download.svg
// module id = 167
// module chunks = 0